import React from 'react';
import { Root } from './styles';
import { LegacyTeaserLabel } from '../primitives';
import { cx } from '@linaria/core';
import { Typo } from '../../primitives/Typo';
import Icon from '../../Icon/Icon';
function Duration({ isLoading, seconds = 0 }) {
    /** Variables */
    const numSeconds = Number(seconds);
    const minutes = numSeconds >= 60 ? Math.round(numSeconds / 60) : '<1';
    /** JSX */
    return !isLoading && numSeconds > 0 ? (React.createElement("span", { className: cx(LegacyTeaserLabel.base, Root.base, Typo.base, Typo.info03) },
        React.createElement(Icon, { name: "playL", type: "solid" }),
        minutes,
        " Min.")) : null;
}
export default Duration;
